<template>
  <div>
    <editQuestion
      @close-editQuestion="toggleEditQuestion"
      :editQuestion="editQuestion"
      :selectedQue="selectedQue"
    />
    <modal
      :show.sync="previewAsset"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Preview
      </h6>
      <div class="pb-8 customboxed">
        <div class="">
          <div
            class="headx cheadx p-4 mb-4"
            v-for="(item, index) in question"
            :key="index"
          >
            <p class="font-normal">
              Question {{ index + 1 }}/{{ question.length }}
            </p>

            <div class="question mt-2">
              <div class="w-full mb-4">
                <h2 class="font-semibold">
                  Q{{ index + 1 }}. {{ item.question }}
                </h2>
              </div>
            </div>
            <div
              class="asnwers flex items-center mb-2"
              v-for="(items, index) in item.option.option"
              :key="index"
            >
              <div class="rounded-full">
                <b-form-radio
                  v-model="item.selected"
                  :value="items.name"
                  :name="'radio-for-' + item.question"
                  class="mb-2"
                  ><p class="font-normal pb-2">
                    {{ items.name }}
                  </p></b-form-radio
                >
                <!-- <b-form-radio
                v-model="selected"
                name="some-radios"
                value="A"
                class="mb-2"
                ><p class="font-normal pb-2">
                  {{ answer.option2 }}
                </p></b-form-radio
              >
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="A"
                class="mb-2"
                ><p class="font-normal pb-2">
                  {{ answer.option3 }}
                </p></b-form-radio
              >
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="A"
                class="mb-2"
                ><p class="font-normal pb-2">
                  {{ answer.option4 }}
                </p></b-form-radio
              > -->
              </div>
            </div>
            <div class="flex">
              <base-button type="primary" @click="editQue(item)"
                >Edit</base-button
              >
              <base-button
                v-if="question.length > 1"
                type="secondary"
                class="ml-8"
                @click="deleteQue(item)"
                >Delete</base-button
              >
            </div>
          </div>
        </div>
      </div>
      <template slot="footer" footer-class="hidden">
        <base-button type="secondary" class="ml-8 hidden">Next</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "../../../scss/Index.scss";
import editQuestion from "./editQuestion.vue";
export default {
  components: {
    editQuestion,
  },
  props: {
    previewAsset: Boolean,
  },
  data() {
    return {
      Answers: [
        {
          option1: "abc",
          option2: "abc",
          option3: "abc",
          option4: "abc",
        },
        {
          option1: "abc",
          option2: "abc",
          option3: "abc",
          option4: "abc",
        },
      ],
      selected: "",
      editQuestion: false,
      question: [],
      selectedQue: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-previewAsses");
    },

    async deleteQue(data) {
      let payload = {
        questionId: data._id,
        chapterId: data.chapter,
        optionId: data.option._id,
      };
      this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value == true) {
          let loader = this.$loading();

          let index = this.question.findIndex(
            (x) => x._id == payload.questionId
          );
          this.question.splice(index, 1);
          const { data } = this.$store.dispatch(
            "eLearning/deleteQuestion",
            payload
          );
          this.$swal("Deleted!", "Your file has been deleted.", "success");
          loader.close();
        }
      });
    },
    editQue(data) {
      this.toggleEditQuestion(true);
      this.selectedQue = data;
      // console.log(this.selectedQue);
    },
    async toggleEditQuestion(val = false) {
      this.editQuestion = val;
    },
  },
  watch: {
    assessments: {
      deep: true,
      handler(newValue, oldValue) {
        // console.log(newValue);
        this.question = newValue[0].question.map((x) => ({
          ...x,
          selected:
            x.option.option[
              x.option.option.findIndex((a) => a.correctAns == true)
            ].name,
        }));
      },
    },
  },
  computed: {
    ...mapState("eLearning", ["assessments"]),
  },
};
</script>

<style>
.custom-control-label::before {
  left: -2rem;
}
.custom-control-label::after {
  left: -2rem;
}
</style>
